/* eslint-disable react/display-name */
import clsx from "clsx";
import React, { HTMLAttributes, ReactNode, forwardRef } from "react";

import { ChevronRightIcon } from "../icons/ChevronRightIcon";

type CollapsibleProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
  className?: string;
  id: string;
  label: ReactNode;
  onToggle(visible: boolean): void;
  visible: boolean;
};

export const Collapsible = forwardRef<HTMLButtonElement, CollapsibleProps>(
  ({ children, className, id, label, onToggle, visible, ...rest }, ref) => {
    return (
      <div>
        <button
          className={clsx(
            "flex justify-between items-center w-full border-b border-edge py-2 pr-[0.6rem]",
            visible && "mb-6"
          )}
          onClick={(): void => {
            onToggle(!visible);
          }}
          aria-controls={id}
          aria-expanded={visible}
          ref={ref}
          type="button"
        >
          <span>{label}</span>
          <ChevronRightIcon
            className={clsx("transition-transform", visible && "rotate-90")}
          />
        </button>
        <div
          className={clsx(
            "mt-2 mb-4 transition-[height]",
            visible ? "h-auto" : "h-0 overflow-hidden",
            className
          )}
          id={id}
          {...rest}
        >
          {children}
        </div>
      </div>
    );
  }
);
